
export default {
  mounted() {
    if (process.browser && this.$store.getters.isMobile) {
      let root = document.querySelector('#__nuxt');
      root.style.paddingBottom = `${this.$el.clientHeight}px`;
      document.querySelector('#__nuxt').classList.add("lg:!pb-0");
    }
  },
};
